var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 27.849,
    viewBox: "0 0 30 27.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38189",
    "data-name": "Path 38189",
    d: "M9.2,16.853H26.892L30,5.737H25.458L23.785.6,16.853,2.749l.956,2.988H17.45L15.777.6,8.845,2.749,9.8,5.737H6.1L5.378,2.629A3.315,3.315,0,0,0,2.151,0H0V1.315H2.151A2.049,2.049,0,0,1,4.183,2.869L7.53,16.135a2.72,2.72,0,0,0-1.2,2.271A2.908,2.908,0,0,0,9.2,21.275H26.414V19.96H9.2a1.554,1.554,0,1,1,0-3.108ZM20.8,22.59a2.629,2.629,0,0,0,0,5.259,2.632,2.632,0,1,0,0-5.259Zm0,4.064a1.434,1.434,0,0,1,0-2.869,1.439,1.439,0,1,1,0,2.869ZM11,22.59a2.629,2.629,0,1,0,2.629,2.629A2.653,2.653,0,0,0,11,22.59Zm0,4.064a1.434,1.434,0,1,1,1.434-1.434A1.453,1.453,0,0,1,11,26.653Zm11.952-24.5,1.2,3.466h-5.02l-.717-2.032Zm-8.008,0,1.2,3.466h-5.02L10.4,3.586ZM28.327,6.932l-2.39,8.606H8.725L6.454,6.932Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.d2fae2a262a43e6a3a447ba0dcc867a1.svg";
export { ForwardRef as ReactComponent };